import React from 'react'

function FindBranch() {
    return (
        <div className="find-branch">
            The branches section is currently in development. coming soon...
            <ul className="bank-details">
                <li>
                    <a href="#"><i className="mobile alternate icon"></i></a>
                </li>
                <li>
                    <a href="#"><i class="at icon"></i></a>
                </li>
                <li>
                    <a href="#"><i class="address book outline icon"></i></a>
                </li>
            </ul>
        </div>
    )
}

export default FindBranch
